// const observerSubscription = new MutationObserver(checkForSubscriptionWidget);
// const config = { childList: true, subtree: true };
// observerSubscription .observe(document.body, config);

// function checkForSubscriptionWidget() {
//   const subscriptionWidget = document.querySelector('[data-v-app]');
//   if (!subscriptionWidget) {
//     // console.log('Subscription widget not found.');
//     return;
//   }
//   const widgetOptionsContainer = subscriptionWidget.querySelector('.rc-template__radio');
//   if (!widgetOptionsContainer) {
//     // console.log('.rc-template__radio not found.');
//     return;
//   }
//   observerSubscription .disconnect();

//   // Create the new custom-div
//   const customDiv = document.createElement('div');
//   customDiv.classList.add('subscription-option-wrapper');

//   // Find the first .rc-radio--active element
//   const firstChild = widgetOptionsContainer.querySelector('.rc-radio--active');
//   if (firstChild) {
//     customDiv.appendChild(firstChild);
//   } else {
//     console.log('.rc-radio--active not found.');
//   }

//   // Find the .rc-subscription-details element
//   const subscriptionDetails = subscriptionWidget.querySelector('.rc-subscription-details');
//   if (subscriptionDetails) {
//     firstChild.appendChild(subscriptionDetails);
//   } else {
//     console.log('.rc-subscription-details not found.');
//   }

//   // Find the .rc-selling-plans element
//   const sellingPlans = widgetOptionsContainer.querySelector('.rc-selling-plans');
//   if (sellingPlans) {
//     widgetOptionsContainer.appendChild(sellingPlans);
//   } else {
//     console.log('.rc-selling-plans not found.');
//   }

//   // Insert customDiv at the beginning of widgetOptionsContainer
//   widgetOptionsContainer.insertBefore(customDiv, widgetOptionsContainer.firstChild);

//   const onetimeRadio = subscriptionWidget.querySelector('.onetime-radio');
//   if (onetimeRadio) {
//     const onetimeRadioLabel = onetimeRadio.querySelector('.rc-radio__label');
//     if (onetimeRadioLabel) {
//       const labelText = onetimeRadioLabel.textContent;
//       const priceMatch = labelText.match(/\$\d+(\.\d{2})?/);
//       if (priceMatch) {
//         const price = priceMatch[0];
//         const newSpan = document.createElement('span');
//         newSpan.classList.add('price-span');
//         newSpan.classList.add('rc-radio__price');
//         newSpan.textContent = price;
//         onetimeRadioLabel.textContent = 'One-time purchase ';
//         onetimeRadioLabel.appendChild(newSpan);
//       } else {
//         console.log('Price not found in .rc-radio__label text.');
//       }
//     } else {
//       console.log('.rc-radio__label not found within .onetime-radio.');
//     }
//     customDiv.appendChild(onetimeRadio);
//   } else {
//     console.log('.onetime-radio not found.');
//   }

//   const subscriptionRadio = subscriptionWidget.querySelector('.subscription-radio');
//   if (subscriptionRadio) {
//     const subscriptionRadioLabel = subscriptionRadio.querySelector('.rc-radio__label');
//     if (subscriptionRadioLabel) {
//       const onetimeRadioPrice = subscriptionWidget.querySelector('.onetime-radio .rc-radio__label .price-span').textContent;

//       const priceContainerDiv = document.createElement('div');
//       priceContainerDiv.classList.add('price-container');

//       const newSpan = document.createElement('span');
//       newSpan.classList.add('product-price-span');
//       newSpan.textContent = onetimeRadioPrice;

//       // Move existing spans to the new div
//       subscriptionRadioLabel.appendChild(priceContainerDiv);

//       const subscriptionPriceSpan = subscriptionRadioLabel.querySelector('.rc-radio__price');
//       if (subscriptionPriceSpan) {
//         priceContainerDiv.appendChild(subscriptionPriceSpan);
//         priceContainerDiv.appendChild(newSpan);
//       }
//     } else {
//       console.log('.rc-radio__label not found within .subscription-radio.');
//     }
//   } else {
//     console.log('.subscription-radio not found.');
//   }

//   // Replace the existing SVG with the new SVG
//   const existingSvg = subscriptionDetails.querySelector('.reload-icon');
//   if (existingSvg) {
//     existingSvg.outerHTML = `
//       <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
//         <mask id="mask0_4457_28115" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
//           <rect width="16" height="16" fill="#D9D9D9"/>
//         </mask>
//         <g mask="url(#mask0_4457_28115)">
//           <path d="M7.33398 11.333H8.66732V7.33301H7.33398V11.333ZM8.00065 5.99967C8.18954 5.99967 8.34787 5.93579 8.47565 5.80801C8.60343 5.68023 8.66732 5.5219 8.66732 5.33301C8.66732 5.14412 8.60343 4.98579 8.47565 4.85801C8.34787 4.73023 8.18954 4.66634 8.00065 4.66634C7.81176 4.66634 7.65343 4.73023 7.52565 4.85801C7.39787 4.98579 7.33398 5.14412 7.33398 5.33301C7.33398 5.5219 7.39787 5.68023 7.52565 5.80801C7.65343 5.93579 7.81176 5.99967 8.00065 5.99967ZM8.00065 14.6663C7.07843 14.6663 6.21176 14.4913 5.40065 14.1413C4.58954 13.7913 3.88398 13.3163 3.28398 12.7163C2.68398 12.1163 2.20898 11.4108 1.85898 10.5997C1.50898 9.78856 1.33398 8.9219 1.33398 7.99967C1.33398 7.07745 1.50898 6.21079 1.85898 5.39967C2.20898 4.58856 2.68398 3.88301 3.28398 3.28301C3.88398 2.68301 4.58954 2.20801 5.40065 1.85801C6.21176 1.50801 7.07843 1.33301 8.00065 1.33301C8.92287 1.33301 9.78954 1.50801 10.6007 1.85801C11.4118 2.20801 12.1173 2.68301 12.7173 3.28301C13.3173 3.88301 13.7923 4.58856 14.1423 5.39967C14.4923 6.21079 14.6673 7.07745 14.6673 7.99967C14.6673 8.9219 14.4923 9.78856 14.1423 10.5997C13.7923 11.4108 13.3173 12.1163 12.7173 12.7163C12.1173 13.3163 11.4118 13.7913 10.6007 14.1413C9.78954 14.4913 8.92287 14.6663 8.00065 14.6663ZM8.00065 13.333C9.48954 13.333 10.7507 12.8163 11.784 11.783C12.8173 10.7497 13.334 9.48856 13.334 7.99967C13.334 6.51079 12.8173 5.24967 11.784 4.21634C10.7507 3.18301 9.48954 2.66634 8.00065 2.66634C6.51176 2.66634 5.25065 3.18301 4.21732 4.21634C3.18398 5.24967 2.66732 6.51079 2.66732 7.99967C2.66732 9.48856 3.18398 10.7497 4.21732 11.783C5.25065 12.8163 6.51176 13.333 8.00065 13.333Z" fill="#1B1F23"></path>
//         </g>
//       </svg>
//     `;
//   } else {
//     console.log('SVG not found.');
//   }

//   const addToCartButtonPrice = subscriptionWidget.querySelector('.subscription-option-wrapper .rc-radio--active .rc-radio__price').textContent;
//   if (addToCartButtonPrice) {
//     document.querySelector('product-info .product-form__submit .block__product-price').innerText = addToCartButtonPrice;
//   }

//   // UPDATE PRICE ON SUBSCRIPTION CHANGE CHANGE
//   const subscriptionWrappers = document.querySelectorAll('.subscription-option-wrapper .rc-radio');
//   subscriptionWrappers.forEach(function(wrapper) {
//     wrapper.addEventListener('change', function() {
//       const priceElement = this.querySelector('.rc-radio__price');
//       if (priceElement) {
//         document.querySelector('product-info .product-form__submit .block__product-price').innerText = priceElement.textContent.trim();
//       }
//     });
//   });

//   const subscriptionDropdown = document.querySelector('.rc-selling-plans-dropdown__select');
//   subscriptionDropdown.addEventListener('change', function() {
//     const subscriptionWidget = document.querySelector('[data-v-app]');
//     const addToCartButtonPrice = subscriptionWidget.querySelector('.subscription-option-wrapper .rc-radio--active .rc-radio__price').textContent;
//     if (addToCartButtonPrice) {
//       document.querySelector('product-info .product-form__submit .block__product-price').innerText = addToCartButtonPrice;
//     }
//   });

//   const subscriptionVariantDropdown = document.querySelector('.rc-radio--active .rc-radio__price').textContent.trim();
//   console.log('subscriptionVariantDropdown',subscriptionVariantDropdown)
  
//   document.querySelector('product-info .product-form__submit .block__product-price').innerText = subscriptionVariantDropdown;


// }
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
  cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) {
          return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
      case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
      case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
      case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
  }
  return formatString.replace(placeholderRegex, value);
  };


jQuery(document).on('change', '.block__product-recharge-widget .subscribe_product', function(){
  if(jQuery(this).parents(".block_product-grid_subscribe").find(".subscribe_product-one").is(":checked")){
    var productItemSellingPlanID =  "";
    var productItemSellingPlanprice =  jQuery(this).next().find(".block_product-grid_subscribe-price").attr("data-price");
  }
  if(jQuery(this).parents(".block_product-grid_subscribe").find(".subscribe_product-multiple").is(":checked")){
    var productItemSellingPlanID = jQuery(this).parents(".block_product-grid_subscribe").find(".selling_plan_dropdown").find(":selected").val();
    var productItemSellingPlanprice =  jQuery(this).next().find(".block_product-grid_subscribe-price").attr("data-price");
  }
  jQuery(this).parents("product-form").find("input[name='selling_plan']").val(productItemSellingPlanID)
  jQuery(this).parents("form").find(".product-form__submit .block__product-price ").text(productItemSellingPlanprice)
});
jQuery(document).on('change', '.block_product-subscribe_drawer select', function(){
  var productItemSellingPlanID = jQuery(this).find(":selected").val();
  $(this).parents("product-form").find("input[name='selling_plan']").val(productItemSellingPlanID)
});
